import { Membresia } from './Membresia';

export class Parametro {
    nombre: string;
    valor: string;
}